// Cálculos del panel de inicio, sin React: se prueban en panel.test.js.

/** Suma de los números de un arreglo; lo que no es número cuenta como 0. */
export const sumar = (valores) =>
  (valores || []).reduce((total, v) => total + (Number.isFinite(Number(v)) ? Number(v) : 0), 0);

/** Copia del arreglo ordenada de mayor a menor según `valor(item)`. */
export const ordenarDeMayorAMenor = (items, valor) =>
  [...(items || [])].sort((a, b) => (Number(valor(b)) || 0) - (Number(valor(a)) || 0));

/**
 * Porcentaje entero de `parte` sobre `total` ("49%"). Una parte que no llega al 1 % se muestra
 * "<1%" y no "0%": un municipio con un cliente no es un municipio sin clientes.
 */
export const textoPorcentaje = (parte, total) => {
  if (!total || !parte) return "0%";
  const pct = (parte / total) * 100;
  return pct < 1 ? "<1%" : `${Math.round(pct)}%`;
};

/**
 * Alto de un gráfico de barras horizontales: una franja por gestor, con un mínimo para que
 * uno o dos gestores no queden en una barra gigante.
 */
export const alturaBarras = (cantidad) => Math.max(220, cantidad * 40 + 48);

// Alto de una fila de la tabla de la dona (y de su encabezado).
const FILA_TABLA = 30;

/**
 * Alto del contenido de una dona con su tabla: en el teléfono la tabla va debajo de la dona; desde
 * sm, al lado, y manda lo que sea más alto.
 */
export const alturaDona = (cantidad, ladoDona) => {
  const tabla = (cantidad + 1) * FILA_TABLA;
  return { xs: ladoDona + 16 + tabla, sm: Math.max(ladoDona, tabla) };
};

/**
 * Porcentaje con un decimal ("12.3%") para los indicadores que comparan dos montos (índice de
 * mora, cumplimiento). Sin base (`total` 0 o vacío) no hay porcentaje: devuelve null.
 */
export const porcentajeConDecimal = (parte, total) => {
  const base = Number(total);
  if (!Number.isFinite(base) || base <= 0) return null;
  return `${(((Number(parte) || 0) / base) * 100).toFixed(1)}%`;
};
